// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"630f33b1","174":"fb2018f7","453":"3776d76e","475":"5ea6385b","984":"72853e3f"}[chunkId] + ".chunk.js";
};